/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import PopUp from '../../../../common/PopUp/PopUp'
import { Redirect } from 'react-router-dom'

export default class IssueContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            softRef: this.props.softReferrals,
            softRefMessage: '',
            reqRate: false,
        }
    }

    componentDidMount() {
        this.props.checkSoftReferral(this.props.quoteId, this.props.varId)
    }

    componentDidUpdate(nextProps: any, nextState: any) {
        if (nextProps.softReferrals !== this.state.softRef) {
            this.setState({ softRef: nextProps.softReferrals })
        }
    }

    /**
     * Function to manage Issue Action
     */
    handleIssue = () => {
        if (this.props.renewal) {
            this.props.inviteQuoteVariation(this.props.values.policyId, this.props.values.id).
                then((response) => {
                    if (response.success !== false) {
                        this.setState({ viewIssuePopUp: true, confirmInvite: false })
                    }
                })
        } else {
            this.props.issueQuoteVariation(this.props.quoteId, this.props.varId)
        }
        this.props.issuedQuotePopUp()
        this.props.handleClosePopup()
    }

    handlePostReasons = () => {
        if (this.props.renewal) {
            this.props.renewalReferralReasons(this.props.values.policyId, { reason: this.state.softRefMessage })
        } else {
            this.props.postSoftReferral(this.props.quoteId, this.props.values.id, { reason: this.state.softRefMessage })
        }
        this.setState({ softRefMessage: '' })
        this.props.postIssuedQuotePopUp()
        this.props.handleClosePopup()
    }

    render() {

        /**
         * If server returns a success response from post_referral_reasons
         * it redirects to Dashboard
         */

        if (this.props.postSoftRef) {
            return (
                <Redirect to="/dashboard" />
            )
        }

        /**
         * Loading
         */
        if (this.state.softRef.loading) {
            return (
                <LoadingComp handleClosePopup={this.props.handleClosePopup} />
            )
        }

        /**
         * Summary to confirm bind
         */
        if (!this.state.softRef.loading && this.state.softRef.response.length === 0) {
            return (
                <ConfirmComp
                    handleClosePopup={this.props.handleClosePopup}
                    handleIssue={this.handleIssue}
                    title={this.props.renewal ?
                        'Do you want to invite this quote?' : 'Do you want to issue this quote?'}
                    buttonText={this.props.renewal ? 'Inivite' : 'Issue'}
                />
            )
        }

        /**
         * List of soft referrals
         */
        if (!this.state.softRef.loading && this.state.softRef.response.length !== 0) {
            return (
                <ListComp
                    handleClosePopup={this.handlePostReasons}
                    changeText={(softRefMessage) => this.setState({ softRefMessage })}
                    referrals={this.state.softRef.response}
                />
            )
        }

        return (
            <div />
        )

    }
}

const ListComp = (props: any) => (
    <PopUp
        title="Referral"
        buttonText="Accept"
        action={props.handleClosePopup}
        numberButtons={1}
    >
        <div className="quotePreview__box softRef">
            Due to the below you will need to provide more information.

            <div className="softRef__list">
                {props.referrals.map((ref, i) => (
                    <div key={i} className="softRef__item">
                        <span>{ref.title}:</span>
                        {ref.description}
                    </div>
                ))}
            </div>

            <textarea
                placeholder="Explain in a few words your reasons"
                onChange={(event) => { props.changeText(event.target.value) }}
            />
        </div>
    </PopUp>
)

const ConfirmComp = (props: any) => (
    < PopUp
        title={props.title}
        buttonText={props.buttonText}
        action={props.handleIssue}
        numberButtons={2}
        secondaryButtonText="Cancel"
        secondaryAction={props.handleClosePopup}
    >
        Are you sure?
    </PopUp >
)

const LoadingComp = (props: any) => (
    <PopUp
        title="Loading"
        buttonText="Loading"
        action={props.handleClosePopup}
        numberButtons={1}
    >
        <div className="quotePreview__box">
            Loading
        </div>
    </PopUp>
)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/components/IssueContainer.tsx